export default __webpack_public_path__ + "static/media/in_store_dsg.837ae106.svg";